import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AddBook from '../components/AddBook';
import Books from '../components/Books/Books';
import fetchBooks from '../redux/products/thunk/fetchBooks';

const Home = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchBooks())
    }, [])
    return (
        <main className="py-12 2xl:px-6">
        <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
          <Books />
          <AddBook />
        </div>
      </main>
    );
};

export default Home;